/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1DiagRightIcon20Solid = forwardRef('ArrowDim1DiagRightIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.25 1.75a1.25 1.25 0 1 0 0 2.5h2.732L4.25 13.982V11.25a1.25 1.25 0 1 0-2.5 0v5a2 2 0 0 0 2 2h5a1.25 1.25 0 1 0 0-2.5H6.018l9.732-9.732V8.75a1.25 1.25 0 1 0 2.5 0v-5a2 2 0 0 0-2-2h-5Z" })));
});
